import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { AppContext } from '../window';
import { useTranslation } from '../i18n';

interface CMSContent {
  content: string;
  language: string;
}

interface TermsConditionsModalProps {
  show: boolean;
  onHide: () => void;
}

export default function TermsConditionsModal({ show, onHide }: TermsConditionsModalProps) {
  const { t } = useTranslation();
  const { texts } = useContext(AppContext);
  const [termsContent, setTermsContent] = useState<CMSContent | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchTermsContent = async () => {
    setLoading(true);
    try {
      const response = await fetch('/site/page?view=terms-conditions&json=1');
      if (response.ok) {
        const data = await response.json();
        setTermsContent(data);
      }
    } catch (error) {
      console.error(t('about.error_fetching_terms_content'), error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && !termsContent) {
      fetchTermsContent();
    }
  }, [show]);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{t('about.terms_conditions')}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">{t('general.loading')}</span>
            </div>
          </div>
        ) : (
          termsContent && (
            <div dangerouslySetInnerHTML={{ __html: termsContent.content }} />
          )
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('general.close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}